import type { Components, Theme } from '@mui/material';
import { fontFamily } from './typography';

export const buildMuiSelectComponent = (): Components<Omit<Theme, 'components'>>['MuiSelect'] => ({
  styleOverrides: {
    standard: {
      fontFamily,
    },
    select: ({ theme }) => ({
      '& .Mui-placeholder': {
        color: theme.palette.primary[60],
        opacity: 1,
        fontWeight: 400,
      },
    }),
  },
});
